import constants from '../constants/actions';
import APP from 'app';

const { Utils } = APP,
    { getJwtToken, saveToCookie, getUserInfoFromJwt } = Utils,
    initialState = {
        getMenubar: [],
        route: '',
        sbt: '',
        replacedUser: {},
        topMenu: []
    };

export default function menubarReducer(state = initialState, action) {
    try {
        const { type = '' } = action;
        switch (type) {
            case constants.MENUBAR.GET_MENUBAR: {
                const sbt = getJwtToken('SBT');
                const { payload = {} } = action;
                const { menubar = [], topbar = [] } = payload;
                return {
                    ...state,
                    type,
                    getMenubar: menubar,
                    topMenu: topbar,
                    sbt
                };
            }
            case constants.MENUBAR.GET_LEFTNAV: {
                const { payload = [] } = action;
                return {
                    ...state,
                    submenu: {
                        ...state.submenu,
                        DASHBOARD: payload
                    }
                };
            }
            case constants.ROUTER.CHANGE_ROUTE: {
                const { payload = [] } = action;
                return {
                    ...state,
                    route: payload,
                };
            }
            case constants.USERINFO.REPLACE_TOKEN: {
                saveToCookie(action.payload, 'SBT');
                const replacedUser = getUserInfoFromJwt();
                return { ...state, replacedUser };
            }
            default:
                return state;
        }

    } catch (error) {
        console.log('Menubar Try catch Error ', error);
        return state;
    }
}
